/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailPayments_user = {|
  +isVip: ?boolean;
  +isVerifiedTrade: ?boolean;
  +canSeeNetPrice: ?boolean;
  +canCheckoutWithCheck: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailPayments_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isVip",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "canSeeNetPrice",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_NET_PRICE",
          "type": "String!"
        }
      ],
      "name": "hasPermission",
      "storageKey": "hasPermission{\"name\":\"B_NET_PRICE\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "canCheckoutWithCheck",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_CHECKOUT_CHECK",
          "type": "String!"
        }
      ],
      "name": "hasPermission",
      "storageKey": "hasPermission{\"name\":\"B_CHECKOUT_CHECK\"}"
    }
  ],
  "type": "User"
};

module.exports = fragment;
